// extracted by mini-css-extract-plugin
module.exports = {"ghIcon":"_48d905f3"};